/**
 * Language Constants and Types
 *
 * Core language definitions and configuration
 */

// Supported languages - must match database constraint and i18n config
export const SUPPORTED_LANGUAGES = ['en', 'es', 'fr', 'sv'] as const;
export type SupportedLanguage = typeof SUPPORTED_LANGUAGES[number];

// Language display names for UI
export const LANGUAGE_NAMES: Record<SupportedLanguage, string> = {
  en: 'English',
  es: 'Español',
  fr: 'Français',
  sv: 'Svenska'
};

// Language display names in their own language
export const NATIVE_LANGUAGE_NAMES: Record<SupportedLanguage, string> = {
  en: 'English',
  es: 'Español',
  fr: 'Français',
  sv: 'Svenska'
};

// Cookie configuration
export const LANGUAGE_COOKIE_NAME = 'i18nextLng';
export const LANGUAGE_STORAGE_KEY = 'i18nextLng';
export const COOKIE_EXPIRY_DAYS = 30;

/**
 * Validates if a language code is supported
 */
export function isValidLanguage(language: string): language is SupportedLanguage {
  return SUPPORTED_LANGUAGES.includes(language as SupportedLanguage);
}